<dx-data-grid #suppliersGrid
  [dataSource]="dataSource"
  [remoteOperations]="false"
  [allowColumnReordering]="false"
  [rowAlternationEnabled]="true"
  [allowColumnResizing]="true"
  height="98%"
>
<dxo-editing
    mode="batch"
    [allowAdding]="true"
    [allowUpdating]="true"
    [allowDeleting]="true"
  >
  </dxo-editing>
  <dxo-scrolling mode="virtual" rowRenderingMode="virtual"></dxo-scrolling>
  <dxo-search-panel [visible]="true"></dxo-search-panel>
  <dxi-column dataField="supplier_code" dataType="string" caption="Code" width="15%">
    <dxi-validation-rule type="required" message="supplier code is required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column dataField="supplier_name" dataType="string" caption="Name">
    <dxi-validation-rule type="required" message="supplier name is required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column dataField="email" dataType="string" caption="Email">
    <dxi-validation-rule type="email" message="Enter a valid email"></dxi-validation-rule>
  </dxi-column>
  <dxi-column dataField="id" dataType="integer" [visible]="false"></dxi-column>
</dx-data-grid>